var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLeftUp = function SvgIconLeftUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.117 3.576a1 1 0 0 0-.324.217l-4.5 4.5a1 1 0 0 0 1.414 1.414L6.5 6.914V18a1 1 0 0 0 1 1H21a1 1 0 1 0 0-2H8.5V6.914l2.793 2.793a1 1 0 0 0 1.414-1.414l-4.5-4.5M8.205 3.79a1 1 0 0 0-1.088-.214"
  }))));
};
export default SvgIconLeftUp;